// extracted by mini-css-extract-plugin
module.exports = {"container":"room__style__container___3Nk3eO","image":"room__style__image___28IhI7","heading":"room__style__heading___Zk0CZX","description":"room__style__description___bq_EwK"};